var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { Refresh } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import Snackbar from "@mui/material/Snackbar";
import { useQuery } from "@tanstack/react-query";
import { getLastVersion } from "@utils/api";
var Updater = function () {
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = useQuery({
        queryKey: ["version"],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getLastVersion()];
                    case 1: return [2 /*return*/, (_a.sent())];
                }
            });
        }); },
        enabled: process.env.NODE_ENV === "production",
        refetchOnWindowFocus: true,
        refetchInterval: 10 * 60 * 1000, // Every minute
    }), newVersion = _b.data, isSuccess = _b.isSuccess;
    useEffect(function () {
        if (isSuccess && newVersion !== process.env.VERSION) {
            setIsOpen(true);
        }
    }, [newVersion, isSuccess]);
    return (React.createElement(Snackbar, { open: isOpen, message: "A new version is available ".concat(newVersion), action: React.createElement(IconButton, { "aria-label": "close", color: "inherit", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                var names;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!caches) return [3 /*break*/, 3];
                            return [4 /*yield*/, caches.keys()];
                        case 1:
                            names = _a.sent();
                            return [4 /*yield*/, Promise.all(names.map(function (name) { return caches.delete(name); }))];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            try {
                                // @ts-expect-error Reloading the page with true is not standard
                                window.location.reload(true);
                            }
                            catch (error) {
                                window.location.reload();
                            }
                            return [2 /*return*/];
                    }
                });
            }); } },
            React.createElement(Refresh, null)) }));
};
export default Updater;
